import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { CustomerDTO } from '../models/customer.model';

@Injectable({ providedIn: 'root' })
export class CustomerDetailService {
  private readonly http = inject(HttpClient);

  getCustomer(customerId: string): Observable<CustomerDTO> {
    return this.http.get<CustomerDTO>(`${environment.apiBaseUrl}/api/v1/admin/customers/${customerId}`);
  }
}
